
export const config = {

  //APP

  app: {
    //The default date format used.
    defaultDateFormat: 'DD/MM/YYYY',
    defaultDateTimeFormat: 'DD/MM/YYYY HH:mm',

    //Parameters used to display specific information in the app's status bar.
    statusBar: {
      showName: true,
      showVersionNumber: true,
      showEnvironment: true
    }
  },



  //AUTOMATION

  automation: {
    //Parameters used when triggering automatic saving actions. 
    autosave: {
      delay: 1000
    },
    //Parameters used when triggering automatic search actions. 
    autosearch: {
      delay: 1000
    }
  },



  //API

  api: {
    //The default date format used for transmitting a date object to the backend.
    dateFormat: 'YYYY-MM-DD'
  },



  //AUTH

  auth: {
    token: {
      //The number of days after which the authentication token expires.
      expiryDays: 10
    }
  },
}